import {
  COMPASS_BACKEND_FORMAT,
  UI_DISPLAY_DATE,
  DATE_TIME_FORMAT,
  SHORT_UI_DISPLAY_DATE,
  MONTH_DATE_DISPLAY,
  YEAR_DISPLAY,
  MONTH_DISPLAY,
  DATE_DISPLAY,
  SHORT_MONTH_DISPLAY,
} from 'constants/date/dateFormats.constant';
import dayjs from 'dayjs';
import { isNil } from 'lodash';

import utc from 'dayjs/plugin/utc';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isBetween from 'dayjs/plugin/isBetween';
import timezone from 'dayjs/plugin/timezone';

dayjs.extend(utc);
dayjs.extend(quarterOfYear);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(isBetween);
dayjs.extend(timezone);

class DateStringTransform {
  #dateJsObject = null;

  _initiateDateJsObject(dateString) {
    const dateJsObject = dayjs.utc(dateString, COMPASS_BACKEND_FORMAT, true);
    this.#dateJsObject = dateJsObject.isValid() ? dateJsObject : null;
  }

  constructor(dateString) {
    this._initiateDateJsObject(dateString);
  }

  set dateString(dateString) {
    this._initiateDateJsObject(dateString);
  }

  get dateString() {
    return this.#dateJsObject;
  }

  set dateObject(dateObject) {
    const dateJsObject = dayjs.utc(dateObject);
    this.#dateJsObject = dateJsObject.isValid() ? dateJsObject : null;
  }

  get dateObject() {
    return this.#dateJsObject;
  }

  getFormattedDate(date, format = COMPASS_BACKEND_FORMAT) {
    return dayjs.utc(date).format(format);
  }

  getFormattedDateTime(date, format = DATE_TIME_FORMAT) {
    return dayjs.utc(date).format(format);
  }

  getETFormattedDateTime(date, format = DATE_TIME_FORMAT) {
    return dayjs.utc(date).tz('America/New_York').format(format);
  }

  convertFormattedDate(date) {
    return new Date(date.replace(/-/g, '/'));
  }

  getTodayDate(format = COMPASS_BACKEND_FORMAT) {
    return dayjs.utc().format(format);
  }

  isValid() {
    return Boolean(this.#dateJsObject);
  }

  formatter(format) {
    const allowedDateFormats = [
      COMPASS_BACKEND_FORMAT,
      UI_DISPLAY_DATE,
      SHORT_UI_DISPLAY_DATE,
      MONTH_DATE_DISPLAY,
      YEAR_DISPLAY,
      MONTH_DISPLAY,
      SHORT_MONTH_DISPLAY,
      DATE_DISPLAY,
    ];

    if (!allowedDateFormats.includes(format)) return null;
    if (isNil(this.#dateJsObject)) return null;

    return this.#dateJsObject.format(format);
  }

  getQuarter() {
    if (isNil(this.#dateJsObject)) return null;
    return this.#dateJsObject.quarter();
  }

  toString() {
    return this.#dateJsObject;
  }
}

export default DateStringTransform;
